import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { GET_ONE, UPDATE } from 'react-admin';
import Tooltip from '@material-ui/core/Tooltip';
// Use material UI button because Tooltip doesn't work with react-admin Button
import Button from '@material-ui/core/Button';

import dataProvider from '../../dataProvider';


class SubmitToFolioButton extends Component {
  state = {
    isSubmitting: false,
    offer: null,
  };

  async componentDidMount() {
    // Get offer for this order to check if offer
    const { data } = await dataProvider(GET_ONE, 'offerings', { id: this.props.record.offerId });
    // Ok to call setState in a promise
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ offer: data });
  }

  handleClick = async () => {
    this.setState({ isSubmitting: true });
    const { resource, record, submitToFolio } = this.props;
    submitToFolio(resource, record.id, {
      onSuccess: () => this.setState({ isSubmitting: false }),
    });
  }

  render() {
    // Pull out props that Button doesn't need
    const { submitToFolio, ...rest } = this.props;
    const {
      folioPrivatePlacementOrderOid,
      status,
      isConditional,
      conditionalMinSharePrice,
      conditionalMaxSharePrice,
    } = this.props.record;

    let disabled = false;
    let tooltipTitle = false;
    if (status !== 'created') {
      disabled = true;
      tooltipTitle = 'Order status is not "created"';
    } else if (folioPrivatePlacementOrderOid) {
      disabled = true;
      tooltipTitle = 'Order already submitted';
    } else if (!this.state.offer) {
      disabled = true;
      tooltipTitle = 'Loading offer';
    } else if (!this.state.offer.folioId) {
      disabled = true;
      tooltipTitle = "This order's offer has no Folio Id";
    } else if (this.state.isSubmitting) {
      disabled = true;
      tooltipTitle = 'Submitting order';
    }
    if (this.state.offer) {
      const {
        pricePerShare,
      } = this.state.offer;
      const isInsideRange = (conditionalMinSharePrice <= pricePerShare && pricePerShare <= conditionalMaxSharePrice);
      if (isConditional && !isInsideRange) {
        disabled = true;
        tooltipTitle = 'Conditional Offer is not eligible for submission ( Share Price not inside range )';
      }
    }

    // When Button is disabled the Tooltip hover doesn't work
    // so explictly "open" the Tooltip
    return (
      <Tooltip title={tooltipTitle} open={disabled}>
        <Button
          onClick={this.handleClick}
          disabled={disabled}
          color="primary"
          size="small"
          {...rest}
        >
          Submit to Folio
        </Button>
      </Tooltip>
    );
  }
}


const submitToFolioAction = (resource, id, meta) => ({
  type: 'SUBMIT_OFFER_ORDER_TO_FOLIO',
  payload: {
    id,
    resource,
    action: 'submit-to-folio',
  },
  meta: {
    fetch: UPDATE,
    resource,
    refresh: true, // refresh this object
    ...meta,
  },
});


SubmitToFolioButton.propTypes = {
  record: PropTypes.shape({
    id: PropTypes.string,
    folioPrivatePlacementOrderOid: PropTypes.string,
  }).isRequired,
  submitToFolio: PropTypes.func.isRequired,
};

export default connect(null, {
  submitToFolio: submitToFolioAction,
})(SubmitToFolioButton);



// WEBPACK FOOTER //
// ./src/components/OfferOrder/SubmitToFolioButton.js